import defaultState from 'redux/defaultState';

export default (ui = defaultState.ui, action) => {
  if (action.type === 'UI_LOADING') {
    return {
      ...ui,
      loading: action.payload
    };
  }

  return ui;
};
